/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "../";
import React from "react";
import { LogoDark } from "~/foundation/Components/Logo";

export const getLightColorTheme = (rtl: boolean): ColorTheme => ({
	name: "Light",
	colors: {
		ribbon: {
			bg: "elementsBackgroundColors.light",
			color: "primary.text",
			border: "primary.neutralGrey",
			linkColor: "primary.aramcoLinkBlue"
		},
		wordExplainer: {
			bg: "primary.white",
			color: "primary.text",
			activeColor: "primary.aramcoLinkBlue"
		},
		header: {
			bg: "elementsBackgroundColors.light",
			bgInactive: "navigationColors.lightBgTransparent",
			color: "primary.darkGrey",
			activeColor: "primary.aramcoLinkBlue",
			hygieneColor: "primary.aramcoGrey",
			hygieneGlobalContacts: "primary.aramcoGrey",
			burgerMenuColor: "primary.darkGrey"
		},
		siteNavigation: {
			gradient: "siteNavigation.lightTheme.gradient",
			bg: "siteNavigation.lightTheme.bg",
			color: "siteNavigation.lightTheme.color",
		},
		footer: {
			bg: "gradients.footerLight",
			color: "primary.text"
		},
		breadcrumb: {
			linkColor: "aramcoBreadcrumb.lightTheme.linkColor",
			activeColor: "aramcoBreadcrumb.lightTheme.activeColor",
			aramcoA: "aramcoBreadcrumb.lightTheme.aramcoA",
			iconColor: "aramcoBreadcrumb.lightTheme.iconColor",
			linkColorCurrentPage: "aramcoBreadcrumb.lightTheme.linkColorCurrentPage",
		},
		generatedCard: {
			bg: "primary.white",
			color: "primary.text",
			linkColor: "primary.aramcoLinkBlue"
		},
		tags: {
			color: "primary.aramcoGrey"
		},
		switch: {
			color: "primary.aramcoLinkBlue",
		}
	},
	Logo: () => <LogoDark height={25} />,
	FooterLogo: () => <LogoDark height={29} />
});